import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MuiAppBar from '@mui/material/AppBar';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useGetProfile, useSignOut } from '../../api/hooks/auth';
import { Link, ListItemIcon, ListItemText, styled } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import InventoryIcon from '@mui/icons-material/Inventory';
import DashboardIcon from '@mui/icons-material/Dashboard';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

export default function HeaderBar({ open, setOpen, title }) {
  const { data: user } = useGetProfile();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorE2, setAnchorE2] = React.useState(null);

  const signOut = useSignOut();

  const handleProfileMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleProfileClose = () => {
    setAnchorEl(null);
  };

  const handleNavMenu = (event) => {
    setAnchorE2(event.currentTarget);
  };
  const handleNavClose = () => {
    setAnchorE2(null);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const switchDrawerOpen = () => {
    setOpen((o) => !o);
  };

  function handleSignOut() {
    handleCloseMenu();
    signOut();
  }

  return (
    <AppBar position="static" open={open}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={switchDrawerOpen}
          edge="start"
          sx={{ display: { xs: 'none', md: 'flex' } }}
        >
          {open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>

        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleNavMenu}
          edge="start"
          size="small"
          sx={{ display: { xs: 'block', md: 'none' }, mr: 3 }}
        >
          {<MenuIcon />}
        </IconButton>
        <Menu
          id="nav-menu"
          anchorEl={anchorE2}
          open={Boolean(anchorE2)}
          onClose={handleNavClose}
          MenuListProps={{
            'aria-labelledby': 'nav-menu',
          }}
        >
          <Link href="/dashboard" sx={{ textDecoration: 'none' }} color="text.primary">
            <MenuItem>
              <ListItemIcon>
                <DashboardIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>داشبورد</ListItemText>
            </MenuItem>
          </Link>
          <Link href="/inventory" sx={{ textDecoration: 'none' }} color="text.primary">
            <MenuItem>
              <ListItemIcon>
                <InventoryIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>انبارداری</ListItemText>
            </MenuItem>
          </Link>
          <Link href="/sales" sx={{ textDecoration: 'none' }} color="text.primary">
            <MenuItem>
              <ListItemIcon>
                <PointOfSaleIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>فروش</ListItemText>
            </MenuItem>
          </Link>
        </Menu>

        <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        <div>
          <Button
            variant="text"
            color="inherit"
            startIcon={<AccountCircle />}
            onClick={handleProfileMenu}
          >
            {user?.fullName}
          </Button>

          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            keepMounted
            open={!!anchorEl}
            onClose={handleProfileClose}
          >
            <MenuItem onClick={handleCloseMenu}>پروفایل</MenuItem>
            <MenuItem onClick={handleSignOut}>خروج</MenuItem>
          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
}
